import { Container } from '@acies/core';
import { IconTitleSection } from '@acies/ui';
import AnswersList from './answers-list';
import AnswersListHeader from './answers-list-header';
import ItemConfigurationRenderer from './item-configuration-renderer';

export default class AnswersSection extends IconTitleSection {
	#container!: Container;
	#answersListHeader!: AnswersListHeader;
	#answersList!: AnswersList;
	#itemConfigurationRenderer!: ItemConfigurationRenderer;
	#scrollContainer!: Container;
	public constructor() {
		super();
		this.width = 'fill';
		this.height = 'fill';
		this.icon = 'clipboard';
		this.text = 'Konfiguration';
	}

	public get container(): Container {
		if (!this.#container) {
			this.#container = new Container();
			this.#container.width = 'fill';
			this.#container.height = 'fill';
			this.#container.autoLayout = 'vertical';
			this.#container.gapVertical = 8;
			this.#container.addComponents([this.answersListHeader, this.scrollContainer]);
		}
		return this.#container;
	}

	/**
	 * What scrolls under the header: the stock configuration's row and the answers below it, as one.
	 *
	 * The row is one of the answers as far as the user is concerned — the configuration the item comes in, picked above the answers it deals — so it scrolls with them rather than staying put, and the scrollbar runs the whole height below the header rather than starting under the row.
	 *
	 * The scrollbar is there from the first row rather than appearing at the one that overflows, so the rows never shift under the header, which is aligned to it once — see `SCROLLBAR_WIDTH`. The list hugs its rows inside it, so this is the one thing that scrolls.
	 */
	public get scrollContainer(): Container {
		if (!this.#scrollContainer) {
			this.#scrollContainer = new Container();
			this.#scrollContainer.width = 'fill';
			this.#scrollContainer.height = 'fill';
			this.#scrollContainer.autoLayout = 'vertical';
			this.#scrollContainer.gapVertical = 8;
			this.#scrollContainer.clipContent = true;
			this.#scrollContainer.alwaysShowVerticalScrollbar = true;
			this.#scrollContainer.addComponents([this.itemConfigurationRenderer, this.answersList]);
		}
		return this.#scrollContainer;
	}

	/** Where a stock position's item configuration is picked, shown only for a stock configuration with configurations to pick among. */
	public get itemConfigurationRenderer(): ItemConfigurationRenderer {
		if (!this.#itemConfigurationRenderer) {
			this.#itemConfigurationRenderer = new ItemConfigurationRenderer();
		}
		return this.#itemConfigurationRenderer;
	}

	public get answersListHeader(): AnswersListHeader {
		if (!this.#answersListHeader) {
			this.#answersListHeader = new AnswersListHeader();
		}
		return this.#answersListHeader;
	}

	public get answersList(): AnswersList {
		if (!this.#answersList) {
			this.#answersList = new AnswersList();
		}
		return this.#answersList;
	}

	protected override initialize(): void {
		super.initialize();
		this.body.addComponents([this.container]);
	}
}
customElements.define('ac-answers-section', AnswersSection);
